export enum MountItemImageStatus {
    DONE = "With Image",
    WITHOUT_IMAGE = "Without Image",
    PENDING_MOUNTING = "Pending Mounting"
}
